/**
 * @file ModalSelect
 */
'use strict'
import areaMapping from '../../Utils/AreaMap'

/**
 * @classname ModalSelect
 * @classdesc モーダルで検索条件が押された時に呼び出し元のボタンをアクティブにする
 */
export default class ModalSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ModalSelect.constructor')
		this._$e = $e
		// const modalId = this._$e.parents('.modal--detail-select').attr('id')
		// this._$parentBtn = $(`[data-target="#${modalId}"]`)

		const areaId = this._$e.closest('.modal .modal-body').attr('data-area-id')
		this._areaMap = areaMapping[areaId];
		this._mappingid = this._$e.attr('data-areaid')
		this._spotMap = this.returnSpotMap(this._areaMap)

		//都道府県
		this._$prefectureGroup = this._$e.closest('.modal').find('.btn-group.prefectures')
		//おすすめスポット
		this._$spotGroup = this._$e.closest('.modal').find('.btn-group.spot')

		$e.on('click', () => this.onClick())

	}



	/**
	 * 都道府県、おすすめスポットが選択された時に、該当しないものは非活性にする
	 */
	 onClick() {

		//都道府県が選択された場合
		if(this._$e.closest('.btn-group').hasClass('prefectures')){

			//選択された都道府県の数
			const selectPrefectureNum = this._$prefectureGroup.find('input:checked').length
			const $selectPrefectures = this._$prefectureGroup.find('input:checked')

			let activeSpots = []

			//全てor何も選択されていない場合
			if(this._mappingid === '00' || selectPrefectureNum === 0) {

				console.log('全てor何も選択されていない場合::')
				//スポットは全部アクティブにする
				this._$spotGroup.find('input').each((idx, spot) => {
					$(spot).prop('disabled', false)
				});
			} else {
				//全て以外の何かしらが選択されている
				//選択された都道府県と紐づくスポットをアクティブにするスポットリストに入れる

				console.log('全て以外の何かしらが選択されている::')
				$selectPrefectures.each((idx, prefecture) => {
					const prefectureId = $(prefecture).attr('data-areaid')
					const values = this._areaMap[prefectureId]
					if (values && values.length) {
						for (let i = 0; i < values.length; i++) {
							activeSpots.push(values[i]);
						}
					}

				});

				//スポットを回してアクティブリストに入っていなければ、非活性化にする
				this._$spotGroup.find('input').each((idx, s) => {
					const spotId = $(s).attr('data-areaid'); 

					if (activeSpots.includes(spotId)) {
						console.log('アクティブリストに含まれている::' + spotId)
						$(s).prop('disabled', false)
					}else {
						console.log('アクティブリストに含まれていない::' + spotId)
						//選択していないものだけをdisabled
						if(!$(s).prop('checked')){
							$(s).prop('disabled', true)
						}
						// $(s).prop('disabled', true)
						// $(s).prop('checked', false)
					}
				});
			}			
		}


		//スポットが選択された場合
		if(this._$e.closest('.btn-group').hasClass('spot')){

			//選択された都道府県の数
			const selectSpotNum = this._$spotGroup.find('input:checked').length
			let activePrefectures = []
			let $targetSpot

			//何も選択されていない場合
			if(selectSpotNum === 0){
				//都道府県は全部アクティブにする
				console.log('スポット　何も選択されていない場合::')
				//スポットは全部アクティブにする
				this._$prefectureGroup.find('input').each((idx, prefecture) => {
					$(prefecture).prop('disabled', false)
				});
			} else{
			//全てが選択されている
				//全てのスポットに紐づく都道府県をアクティブリストに追加する
				if(this._mappingid === '10') {
					$targetSpot = this._$spotGroup.find('input')
				//選択されたスポットに紐づく都道府県をアクティブリストに追加する
				}else{
					$targetSpot = this._$spotGroup.find('input:checked')
				}

				$targetSpot.each((idx, taget) => {
					const sid = $(taget).attr('data-areaid')
					const spotvalue = this._spotMap[sid]

					if (spotvalue && spotvalue.length) {
						for (let i = 0; i < spotvalue.length; i++) {
							activePrefectures.push(spotvalue[i]);
						}
					}

					console.log('activePrefectures1::' + activePrefectures)

				});



				this._$prefectureGroup.find('input').each((idx, p) => {
					const pid = $(p).attr('data-areaid'); 

					console.log('activePrefectures::' + activePrefectures)
					if (activePrefectures.includes(pid)) {
						console.log('アクティブリストに含まれている::' + pid)
						$(p).prop('disabled', false)
					}else {
						console.log('アクティブリストに含まれていない::' + pid)
						//選択していないものだけをdisabled
						if(!$(p).prop('checked')){
							$(p).prop('disabled', true)
						}
						// $(p).prop('disabled', true)
						// $(p).prop('checked', false)
					}
				});
			}

		}
	}

	 returnSpotMap(areaMap) {
		const spotMap = {};
		for (const prefectureKey in areaMap) {
			const spots = areaMap[prefectureKey];
			for (const key in spots) {
				const spotID = spots[key];

				if (!spotMap[spotID]) {
					spotMap[spotID] = [];
				}
				spotMap[spotID].push(prefectureKey);

				console.log('spotID::' + spotID + '::' + spotMap[spotID])
			}
		}
		return spotMap
	}	
}
